// src/appDataUtils.js

import { getLoginUserData, getUsersListData } from "./redux/feature/userSlice";
import {
  getQuotation,
} from "./redux/feature/supplier_app/sourcingSlice";
import { getMenuOnUserRole } from "./redux/feature/supplier_app/menuSlice";
import { getConstantVariable } from "./redux/feature/supplier_app/commonSlice";
import {
  getPurchaseOrderCustomerV2,
  getRfqleList,
} from "./redux/feature/customer_app/customerSlice";

export const initializeAppData = (dispatch, defaultAppCode) => {
  if (defaultAppCode !== "") {
    // console.log(">> AppDataUtils >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", defaultAppCode);

    // Dispatch actions for setting menu and constants
    const menuPayload = { application: "CUSTOMER" };
    dispatch(getMenuOnUserRole(menuPayload));
    dispatch(getConstantVariable({}));
    dispatch(getLoginUserData({}));
    dispatch(getUsersListData(menuPayload));

    // Check for specific user data and dispatch additional actions if needed
    if (defaultAppCode === "CUSTOMER") {
      dispatch(getRfqleList({}));
      dispatch(getQuotation({}));
      dispatch(getPurchaseOrderCustomerV2({}));
    } 
  }
};
